export default __webpack_public_path__ + "static/download-apple-app-store-49d9071fe3a1ba931c0a94d0ab37b4a3.svg";